import React, { PureComponent } from 'react';
import { Collapse } from 'reactstrap';

export default class SidebarCategory extends PureComponent {
  state = {
      collapse: false,
  };

  toggle = () => this.setState({ collapse: !this.state.collapse });

  render() {
      const { collapse } = this.state; const
          { icon, children, title } = this.props;
      return (
          <div className={`sidebar__category-wrap${collapse ? ' sidebar__category-wrap--open' : ''}`}>
              <li className="sidebar__link sidebar__category" onClick={this.toggle}>
                  {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
                  <p className="sidebar__link-title title" style={{ top: 5 }}>{title}</p>
                  <span className="sidebar__category-icon lnr lnr-chevron-right" />
              </li>
              <Collapse isOpen={collapse} className="sidebar__submenu-wrap">
                  <ul className="sidebar__submenu">
                      <div>{children}</div>
                  </ul>
              </Collapse>
          </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/modules/App/components/sidebar/SidebarCategory.js